import React, { PureComponent } from 'react';
import { withStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';
import { ContextMenu, MenuItem } from '@naumandev/react-context-menu';
import { compose } from 'redux';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import {
  OpenInNew,
  ExpandLess,
  ExpandMore
} from '@mui/icons-material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import { connect } from 'react-redux';
import Card from '@mui/material/Card';

import { setDialog } from '../../actions/dialog';
import withRouter from '../../hoc/withRouter';

const mapStateToProps = ({ users, connectedUser }) => ({
  user: connectedUser,
  users,
  userId: connectedUser._id,
});

const mapDispatchToProps = {
  setConnectedDialog: setDialog,
};

function getter(obj, arg) {
  if (typeof arg !== 'string') {
    return null;
  }

  arg = arg.split('.');
  arg.forEach(e => {
    if (obj) {
      obj = obj[e]
    }
    return null;
  });
  return obj;
}

function exists(key, obj) {
  return !key || (obj && key && getter(obj, key));
}

function isVisible(elem, props) {
  if (elem.customVisible) {
    return elem.customVisible(elem, props);
  }
  return exists(elem.visible, props.selected);
}

const styles = () => ({
  iconButton: {
    height: 32,
    padding: '0px 0px',
  },
  menuText: {
    padding: '0px 16px',
  },
  menuItem: {
    marginLeft: 5,
    marginBottom: 5,
    marginRight: 5,
  },
  contextMenu: {
    zIndex: 100,
    minWidth: 250
  },
  notAuthorized: {
    height: 50,
    width: 250,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '3px solid red',
  },
});

class ListContextMenu extends PureComponent {
  state = {
    open: '',
  };

  handleExpand = (e, data) => {
    this.setState({ open: this.state.open === data.name ? '' : data.name });
  };

  handleClick = (e, data) => {
    data.action(
      {
        ...this.props,
        user: this.props.user,
      },
      data.elem
    );
  };

  handleNewOpen = (e, elem) => {
    e.stopPropagation();
    elem.link(this.props.selected);
  };

  genItem = (elem, i) => {
    const { classes, selected } = this.props;
    const name =
      typeof elem.name === 'function' ? elem.name(this.props) : elem.name;
    const value =
      selected
      && elem.value
      && (typeof elem.value === 'function'
        ? elem.value(this.props, selected)
        : getter(this.props.selected, elem.value)
      )
    const Link = () => <ListItemSecondaryAction children={
      <IconButton
        edge="end"
        onClick={e => this.handleNewOpen(e, elem)}
        children={<OpenInNew />}
        size="large" />
    } />;
    const item = (typeof elem.value === 'function'
      ? elem.value(this.props, selected)
      : exists(elem.value, selected)
    )
    && isVisible(elem, this.props)
    && (
      <ListItem key={i} button>
        {elem.icon ? <elem.icon /> : ''}
        <ListItemText
          className={classes.menuText}
          primary={name}
          secondary={
            value
          }
        />
        {elem.link && <Link />}
      </ListItem>
    );
    return (
      <MenuItem
        key={elem.name}
        data={{ action: elem.action }}
        onClick={this.handleClick}
      >
        {item}
      </MenuItem>
    );
  };

  render() {
    const {
      actions,
      idMenu,
      classes
    } = this.props;
    const { open } = this.state;
    const hasAuthorization = actions.some(e => isVisible(e, this.props));

    return (
      <ContextMenu id={idMenu || 'SIMPLE'} className={classes.contextMenu}>
        <Paper className="contextMenu">
          {hasAuthorization ?
            <List>
              {actions.map(elem => {
                const name =
                  typeof elem.name === 'function'
                    ? elem.name(this.props, elem)
                    : elem.name;
                return (
                  (elem.action && this.genItem({ ...elem, name })) ||
                  (isVisible(elem, this.props) && (
                    <span key={name}>
                      <MenuItem
                        data={{ name }}
                        onClick={this.handleExpand}
                        preventClose
                      >
                        <ListItem button>
                          <elem.icon />
                          <ListItemText
                            className={classes.menuText}
                            primary={name}
                          />
                          {open === name ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                      </MenuItem>
                      <Collapse
                        in={open === name}
                        timeout="auto"
                        unmountOnExit
                        children={elem.sub.map(this.genItem)}
                      />
                    </span>
                  ))
                );
              })}
            </List>
            :
            <Card variant="outlined" className={classes.notAuthorized}>
              Accès non autorisé.
            </Card>
          }
        </Paper>
      </ContextMenu>
    );
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(withStyles(ListContextMenu, styles));
